import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { Pagination } from 'src/app/shared/models/pagination.model';

//ALL THE COMMON FUNCTIONS USED ACROSS APP ARE LISTED HERE
@Injectable({
  providedIn: 'root'
})
export class GeneralFunctions {

  //API RESPONSE ERROR HANDLER
  public handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    }
    else {
      errorMessage = `Error Code: ${error.status}\nMessage:${error.message}`;
    }

    return throwError(errorMessage);
  }

  /*
   * IN-BUILT EMAIL VALIDATOR IS NOT WORKING IN ANGULAR 10
   * HENCE A CUSTOM VALIDATION IS KEPT HERE
  */
  public emailValidator(control) {
    if (control.value) {
      const matches = control.value.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$");
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }


  public paginate(
    totalItems: number,
    currentPage: number = 1,
    pageSize: number = 10,
    maxPages: number = 10
  ) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    // ensure current page isn't out of range
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    let startPage: number, endPage: number;
    if (totalPages <= maxPages) {
      // total pages less than max so show all pages
      startPage = 1;
      endPage = totalPages;
    } else {
      // total pages more than max so calculate start and end pages
      let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
      let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
      if (currentPage <= maxPagesBeforeCurrentPage) {
        // current page near the start
        startPage = 1;
        endPage = maxPages;
      } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
        // current page near the end
        startPage = totalPages - maxPages + 1;
        endPage = totalPages;
      } else {
        // current page somewhere in the middle
        startPage = currentPage - maxPagesBeforeCurrentPage;
        endPage = currentPage + maxPagesAfterCurrentPage;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);

    // return object with all pager properties required by the view
    let retPage = new Pagination();

    retPage.totalItems = totalItems;
    retPage.currentPage = currentPage;
    retPage.pageSize = pageSize;
    retPage.totalPages = totalPages;
    retPage.startPage = startPage;
    retPage.endPage = endPage;
    retPage.startIndex = startIndex;
    retPage.endIndex = endIndex;
    retPage.pages = pages;

    return retPage;
  }

  public cipherPhoneNumber(input: string) {
    let retString: string = '';

    if (input.substring(0, 2) == '+1') {
      input = input.substring(2, input.length);
    }

    retString = input.substring(0, 2) + '*** ***' + input.substring(input.length - 2);

    return retString;
  }

  public isBrowserIE() {
    return window.document['documentModel'];
  }

  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
}
